import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconDeleteOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m18.476 20.784.271-13.228h1.5l-.27 13.259A3.25 3.25 0 0 1 16.723 24H5.887a3.25 3.25 0 0 1-3.25-3.185l-.273-13.26h1.5l.271 13.229c.02.946.806 1.716 1.752 1.716h10.837c.947 0 1.733-.77 1.752-1.716M1.5 3H21a.749.749 0 1 1 0 1.5H1.5a.749.749 0 1 1 0-1.5m14.25-1.5h-9a.749.749 0 1 1 0-1.5h9a.749.749 0 1 1 0 1.5" /></svg>
);
